import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import Form from '../forms/Form.js'

export default function List({ shopperId }) {
  const { isLoading, error, data } = useQuery(['forms', shopperId], () => Form.list(shopperId), {
    placeholderData: []
  })

  return (
    <Container>
      {isLoading && (
        <Row className='pt-3'>
          <Col>
            <Alert variant='info'>
              Loading...
            </Alert>
          </Col>
        </Row>
        )}
      {error && (
        <Row className='pt-3'>
          <Col>
            <Alert variant='danger'>
              {error}
            </Alert>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <h1 className='display-6'>Forms</h1>
        </Col>
        <Col>
          <Link to={`/shoppers/new`} className='btn btn-primary'>
            New Shopper
          </Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Status</th>
                <th>Submitted At</th>
                <th>User</th>
              </tr>
            </thead>
            <tbody>
            { data.map((form) => (
              <tr key={form.id}>
                <td>
                  <Link to={`/forms/${form.id}`}>
                    {form.id}
                  </Link>
                </td>
                <td className='text-truncate'>{form.form_status}</td>
                <td className='text-truncate'>{form.submitted_at}</td>
                <td className='text-truncate'>{form.user_id}</td>
              </tr>
            ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  )
}